import { useEffect, useMemo, useState } from "react";
import { useSiteConfig } from "@/contexts/SiteConfigContext";
import api from "@/lib/api";
import { FilterChips, PageHero, ProjectCard } from "@/components/site/parts";
import { useCopy } from "@/lib/copy";

export default function Projects() {
  const { config } = useSiteConfig();
  const t = useCopy();
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [cat, setCat] = useState("All");

  useEffect(() => {
    api.get("/projects").then(({ data }) => setProjects(data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const cats = useMemo(
    () => ["All", ...Array.from(new Set(projects.map((p) => p.category).filter(Boolean)))],
    [projects],
  );
  const shown = cat === "All" ? projects : projects.filter((p) => p.category === cat);

  return (
    <>
      <PageHero
        kicker={t("projects.kicker")}
        title={t("projects.title")}
        accent={t("projects.accent")}
        sub={t("projects.sub")}
        aside={
          <div className="rise d4 mono project-stats">
            <span>PROJECTS</span><span>YEARS</span>
            <span className="disp">{projects.length}</span>
            <span className="disp">{config.years_experience}</span>
          </div>
        }
      />
      <section className="bx" style={{ paddingTop: 40 }}>
        <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "space-between", alignItems: "center", gap: 16, marginBottom: 24 }}>
          {cats.length > 2 ? <FilterChips label="Filter by category" options={cats} value={cat} onChange={setCat} /> : <span />}
          <span className="kicker">{shown.length} PROJECTS</span>
        </div>
        {loading ? (
          <p className="kicker">Loading projects…</p>
        ) : shown.length === 0 ? (
          <div className="empty">{t("projects.empty")}</div>
        ) : (
          <div className="g3">
            {shown.map((p) => <ProjectCard key={p.id} project={p} index={projects.indexOf(p)} full={false} />)}
          </div>
        )}
      </section>
    </>
  );
}
